module.exports = __webpack_public_path__ + "img/GW.eabafc09.svg";